import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const StyledTypingText = styled.span`
    white-space: pre-wrap;
    display: inline;
`;

export const AnimatedChunk = styled.span`
    display: inline;
    animation: ${fadeIn} 0.3s ease-out;
`;
